/*
 * back-to-top.js
 * Web component <back-to-top>: mostra un bottone flottante dopo ~300px di
 * scroll e riporta in cima alla pagina con scorrimento fluido (istantaneo se
 * l'utente ha prefers-reduced-motion). Registrato globalmente via theme-scripts.
 */

class BackToTop extends HTMLElement {
  static THRESHOLD = 300; // px di scroll oltre i quali il bottone compare
  static VISIBLE_CLASS = 'is-visible';

  button;
  ticking = false;

  constructor() {
    super();
    this.button = this.querySelector('button');
  }

  connectedCallback() {
    // Progressive enhancement: senza JS il bottone resta [hidden] e non appare.
    this.hidden = false;

    this.button?.addEventListener('click', this.scrollToTop);
    window.addEventListener('scroll', this.onScroll, { passive: true });

    // Stato iniziale coerente col punto di scroll gia' presente al caricamento.
    this.update();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.scrollToTop);
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll = () => {
    // Throttle su requestAnimationFrame: un solo aggiornamento per frame.
    if (this.ticking) return;
    this.ticking = true;
    window.requestAnimationFrame(() => {
      this.update();
      this.ticking = false;
    });
  };

  update = () => {
    const shouldShow = window.scrollY > BackToTop.THRESHOLD;
    this.classList.toggle(BackToTop.VISIBLE_CLASS, shouldShow);
  };

  scrollToTop = () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  };
}

customElements.define('back-to-top', BackToTop);
